/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useReducer, useMemo, useEffect } from "react";
import React, { useState } from "react";
import UtilityService from "services/API/utility/UtilityService";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";


const FarFieraUI = createContext();

// Setting custom name for the context which is visible on react dev tools
FarFieraUI.displayName = "FarFieraUIContext";

function reducer(state, action) {

  switch (action.type) {
  
    case "MANIFESTAZIONE": {
      return { ...state, manifestazione: action.value };
    }
   case "STATO_MANIFESTAZIONE": {
      return { ...state, stato_manifestazione: action.value };
    }
    case "ISCRIZIONI_APERTE": {
      return { ...state, iscrizioni_aperte: action.value };
    }
     case "MAN_ATTIVA": {
      return { ...state, man_attiva: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}


function FarFieraUIControllerProvider({ children }) {

  const initialState = {
   
    manifestazione: "",
    stato_manifestazione:0 ,
    iscrizioni_aperte:false,
    man_attiva:false,
  };

  const [ffcontroller, ffdispatch] = useReducer(reducer, initialState);


   useEffect(() => {
    const fetchDefaultManifestazione = async () => {
      try {
                 console.log("CERCO LA MAN DI DEFAULT");
        const response = await UtilityService.getManDefault();
        if (!response.errors) {
          const data = response.data;
       

            console.log(data);
            // Aggiorna direttamente lo stato del reducer
          ffdispatch({ 
              type: "MANIFESTAZIONE", 
              value: data.nome_manifestazione
            });
             
               // Aggiorna direttamente lo stato del reducer
            ffdispatch({ 
              type: "STATO_MANIFESTAZIONE", 
              value: data.stato_manifestazione 
            });

                 // Aggiorna direttamente lo stato del reducer
            ffdispatch({ 
              type: "ISCRIZIONI_APERTE", 
              value: data.iscrizioni_aperte
            });
              ffdispatch({ 
              type: "MAN_ATTIVA", 
              value: data.attiva
            });
          
        }
      } catch (e) {
        console.log(e);
      }
    };

    fetchDefaultManifestazione();
  }, []);

  const value = useMemo(() => [ffcontroller, ffdispatch], [ffcontroller, ffdispatch]);

  return <FarFieraUI.Provider value={value}>{children}</FarFieraUI.Provider>;
}


function useFarFieraUIController() {

  const context = useContext(FarFieraUI);

  if (!context) {
    throw new Error(
      "useFarFieraUIController should be used inside the MaterialUIControllerProvider."
    );
  }

  return context;
}

// Typechecking props for the MaterialUIControllerProvider
FarFieraUIControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setManifestazione = (ffdispatch, value) => ffdispatch({ type: "MANIFESTAZIONE", value });
const setStatoMan = (ffdispatch, value) => ffdispatch({ type: "STATO_MANIFESTAZIONE", value });
const setIscrizioni_aperte = (ffdispatch, value) => ffdispatch({ type: "ISCRIZIONI_APERTE", value });
const setMan_attiva = (ffdispatch, value) => ffdispatch({ type: "MAN_ATTIVA", value });
export {
 FarFieraUIControllerProvider,
  useFarFieraUIController,
  setManifestazione,
  setStatoMan,setIscrizioni_aperte,setMan_attiva
};
